module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")]), _c('br'), _c('br'), _vm._v("Unconscious Anxiety and Defenses")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "1",
      "src": "images/line.jpg",
      "width": "256"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("ttachment trauma–based unconscious pain, rage, and guilt trigger unconscious anxiety and unconscious defenses against that anxiety ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02fig1"
    }
  }, [_vm._v("fig. 2.1")]), _vm._v("). This relationship is referred to as the "), _c('em', [_vm._v("Triangle of Conflict")]), _vm._v(" (Malan 1979). That is why we say that unconscious anxiety and defenses are "), _c('em', [_vm._v("signals")]), _vm._v(" of unconscious feelings.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "ch02fig1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "205",
      "src": "images/f0011-01.jpg",
      "width": "399"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-cap"
  }, [_vm._v("Figure 2.1 The triangle of conflict")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Let’s review the different patterns of unconscious anxiety and corresponding patterns of unconscious defense you will see.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("STRIATED (VOLUNTARY) MUSCLE UNCONSCIOUS ANXIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first pattern is "), _c('em', [_vm._v("striated muscle unconscious anxiety")]), _vm._v(" (Davanloo 2001; Abbass 2005). Striated muscle is the voluntary muscle of the body—muscle you can move on purpose. Anxiety in the striated muscle starts in the thumb and goes up the hand, arm, shoulder, and neck. Then it goes to the chest, abdomen, legs, and feet. This neurobiological process follows a progression up the side of the cerebral cortex. When "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("it is activated, you will see hand clenching and sighing respirations as the muscles of the chest and diaphragm contract and relax.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("A person with anxiety in this pathway will have spasms, pains, and aches such as seen in fibromyalgia, headache, backache, neck pain, shoulder pain, chest pain, and abdominal wall pain. A person can experience hyperventilation with dizziness, tingling in the hands and feet, and a sense of shortness of breath as is seen with panic. Further, choking sensations, vocal problems, tics, and tremors can be caused or worsened by unconscious anxiety in the relevant striated muscle. A partial list of medical presentations related to striated muscle anxiety is shown in "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02tab1"
    }
  }, [_vm._v("table 2.1")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tab-cap",
    attrs: {
      "id": "ch02tab1"
    }
  }, [_c('strong', [_vm._v("Table 2.1 Striated-muscle-related medical presentations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Tension headaches")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Chest pain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Jaw pain, teeth grinding")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Shortness of breath")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Choking sensations")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Abdominal wall pain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Vocal and other tics")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Leg pain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Neck pain")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Cramps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Fibromyalgia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Tremors")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Back pain")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  })])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Case Vignette: Striated Muscle Unconscious Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man with fibromyalgia, with chronic pain related to stiff muscles, is sitting with hands firmly clenched while describing a conflict with his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Therapist (Th):")]), _vm._v(" What kind of conflict was it? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Patient (Pt):")]), _vm._v(" Um, well, problems with the neighbors. My wife’s opinion was that I spent too much time arguing with this man, and she was probably right.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So she brought this up again in the incident? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Um-hmm.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" And how did you feel? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Well, I’m getting tired of hearing about this.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How do you feel toward her? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" ["), _c('em', [_vm._v("Sighs deeply")]), _vm._v(".] Mad.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Mad, like you mean angry? ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Angry, yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How do you experience the anger inside, physically inside your body? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I’m very, very tense.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" That’s tension. That’s anxiety. ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Anxiety, yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" But how did you experience the anger toward her? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" It’s hard to explain.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" You became anxious, did you? ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah, I became anxious.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Do you become tense when you have anger, become anxious when you have anger inside? ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah, and then I start to ignore her.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" That’s a mechanism you use to deal with the anger? ["), _c('em', [_vm._v("Clarification")]), _vm._v(".] But how do you experience the anger underneath? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Like I say, it’s really hard to put a word on that. I get really mad, okay.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So it’s like rage, you mean.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" It’s like rage, yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How do you experience the rage? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" ["), _c('em', [_vm._v("Sighs deeply")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this segment, focus or pressure on the patient to identify his feelings toward his wife activated unconscious anxiety in the striated muscle: rather than feel the feelings, he just became tense and sore in his body.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("ISOLATION OF AFFECT")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was this man able to intellectually tell me how he felt toward his wife? When I said how did you feel toward her, what did he say? He said “Mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He is able to intellectually label his feeling, but does he experience the feeling in his body? No, he just becomes frozen with tension. Does he notice this? No. He can describe the intellectual label (anger) but not the physical experience of his feeling. This is called "), _c('em', [_vm._v("isolation of "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("affect")]), _vm._v(". When the person can intellectualize and isolate his affect from his experience, anxiety is discharged into the striated muscle. This capacity is parallel to the ability to self-reflect through activation of the dorsolateral prefrontal cortex. Davanloo calls the groups of defenses against the experience of murderous rage operating in treatment sessions "), _c('em', [_vm._v("major resistances")]), _vm._v(". Isolation of affect is the first one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anxiety in the striated muscle is the best pattern to have, except in this patient’s case the degree of chronic tension he had caused a lot of muscle pain. When he experienced the underlying rage and guilt, his tension and pain dropped rapidly.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("SMOOTH MUSCLE UNCONSCIOUS ANXIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The second pathway of unconscious anxiety involves the "), _c('em', [_vm._v("smooth muscle")]), _vm._v(". Smooth muscle is involuntary muscle over which a person has no control, located in the airways, bowel, and blood vessels. The muscle in the bladder is similar but is called "), _c('em', [_vm._v("transitional muscle")]), _vm._v(". People with a lot of anxiety channeled to this muscle suffer from many somatic symptoms requiring referral to medical specialists. A partial list of these common presentations is shown in "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02tab2"
    }
  }, [_vm._v("table 2.2")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tab-cap",
    attrs: {
      "id": "ch02tab2"
    }
  }, [_c('strong', [_vm._v("Table 2.2 Smooth-muscle-related medical presentations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Medical specialty")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Smooth-muscle-related condition")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Cardiology")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Hypertension, coronary spasm, flushing, hypotension with loss of consciousness")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Respirology")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Asthma, coughing, choking symptoms")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Gastroenterology")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Irritable bowel syndrome, gastroesophageal reflux disease, functional vomiting, unexplained abdominal pain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Urology")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Bladder dysfunction, interstitial cystitis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Neurology")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Migraine")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("If unconscious anxiety goes into smooth muscle when the therapist focuses on emotions, he will see no striated muscle tension. These patients seem relaxed because they don’t exhibit visible muscle tension. Since they don’t look anxious, they end up in medical settings rather than psychologists’ offices. Patients with unconscious anxiety in this pathway frequently have two or more of the conditions listed: in our own large sample (Johansson, Town, and Abbass 2014), one half of the patients with migraine headaches also have irritable bowel syndrome.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('strong', [_vm._v("Case Vignette: Smooth Muscle Unconscious Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A middle-aged woman with migraines and irritable bowel syndrome is sitting looking very calm with no visible muscle tension.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can you tell me an example of when you had a conflict so we can see how it affects your symptoms? ["), _c('em', [_vm._v("Pressure to be specific, pressure to task")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" If I ever get in a conflict with someone, I get a headache. ["), _c('em', [_vm._v("Suggestion of link to complex feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can you describe a specific time this happened? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" It happens with my husband sometimes.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can you tell me an example of when that happened? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yes, once when my husband had spent all our money on a trip and we had none left for our rent, I was so mad I yelled at him. A while later I got a headache and nausea.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So you did the action of yelling, but how did you feel toward him? ["), _c('em', [_vm._v("Clarification of action versus feeling, pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I thought, “I’m not a good wife.” ["), _c('em', [_vm._v("No display of signals of striated muscle anxiety")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" You mean you became critical of yourself? ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yes, I was. My stomach doesn’t feel good right now.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can you tell me what you notice in your stomach? ["), _c('em', [_vm._v("Intellectual review to reduce anxiety and isolate affect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" There are cramps here, like bloating coming on. ["), _c('em', [_vm._v("Points to her middle abdomen")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So when we talk about this situation of conflict and frustration, your stomach reacts. Is that what happened? ["), _c('em', [_vm._v("Recap: feelings-anxiety")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yes, it seems to.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So is this a way that frustration with your husband goes, to your stomach or to a headache somehow? Because when you start to talk about your frustration toward him, your stomach reacts here and out there you got a headache. ["), _c('em', [_vm._v("Repeat of recap")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yes, it did.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can we examine that? How that happens here? ["), _c('em', [_vm._v("Pressure to task and patient’s will")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I would sure like to.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('strong', [_vm._v("Monitoring of Response")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The therapist observes that the patient looks completely relaxed with no striated muscle tension. This woman’s anxiety is not discharged into the striated muscle but is being "), _c('em', [_vm._v("repressed")]), _vm._v(" into the smooth muscle in the gastrointestinal tract. In the actual event it appeared to produce a headache. The patient also has a tendency to self-criticize when she has anger with someone else, another typical finding in patients with "), _c('em', [_vm._v("repression")]), _vm._v(". To confirm that anxiety is channeling to the smooth muscle and to ascertain the level of anxiety intolerance this patient has, the therapist repeats the process with another focus.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Can you tell me what happens when we are here together? What feelings come up here with me as we talk together? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Well, I don’t know. ["), _c('em', [_vm._v("Smiles but shows no visible tension")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Let’s see what feelings come up here generating this stomach effect. ["), _c('em', [_vm._v("Repeat of pressure")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I … my stomach is reacting again. ["), _c('em', [_vm._v("Again appears totally relaxed with no striated muscle response")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So again when you speak of your feelings, your stomach reacts with cramps. ["), _c('em', [_vm._v("Recapitulation, linking of feelings with anxiety")]), _vm._v(".]")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Assessment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The therapist confirmed that this woman’s unconscious anxiety was not discharged to the striated muscle but rather into the smooth muscle of her bowel. She had limited ability to isolate affect or intellectualize about her emotions. These findings show that rapid mobilization of unconscious feelings could worsen her gastrointestinal symptoms because her anxiety exceeded the threshold of her anxiety tolerance. Hence, before helping her to be able to tolerate her unconscious emotions, the therapist needs to build her anxiety tolerance through the "), _c('em', [_vm._v("graded format of ISTDP")]), _vm._v(" reviewed in "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" (Davanloo 1995b, c; Whittemore 1996; Abbass and Bechard 2007).")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("REPRESSION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was this woman able to identify which emotions she was feeling? No. She started to talk about when she was irritated but ended up "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("talking about where the feelings went—into the stomach. The emotions were "), _c('em', [_vm._v("instantly repressed")]), _vm._v(". The feelings did not reach consciousness but instead were repressed into the body. Recent research suggests this process is mediated at least in part by the subgenual part of the anterior cingulate cortex. Depressed patients with overactivity in this region do not respond to cognitive therapy, cognitive behavioral therapy, or certain antidepressants (Abbass, Nowoweiski, et al. 2014).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Repression is the second category of major resistance. Repression is an unconscious process where emotions are shunted away from consciousness. This is different than "), _c('em', [_vm._v("suppression")]), _vm._v(", where the patient consciously avoids emotions.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COGNITIVE-PERCEPTUAL DISRUPTION")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Cognitive-perceptual disruption occurs when unconscious anxiety interrupts a person’s special senses and ability to think. Some of the many manifestations of this anxiety pathway include interruption of vision or hearing with what is better known as "), _c('em', [_vm._v("sensory conversion")]), _vm._v(". A person can transiently go completely blind or deaf. The mind goes blank and the person can even lose consciousness with a fainting attack or a pseudoseizure type of event. The person can hallucinate when anxious: thus, he may actually experience transient psychotic phenomena. These patients end up seeing the neurologist and having special tests like magnetic resonance imaging scans, and some patients are misdiagnosed as having psychosis. A partial list of clinical presentations of cognitive-perceptual disruption is in "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02tab3"
    }
  }, [_vm._v("table 2.3")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tab-cap",
    attrs: {
      "id": "ch02tab3"
    }
  }, [_c('strong', [_vm._v("Table 2.3 Cognitive-perceptual-disruption-related medical presentations")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "100%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Visual blurring, visual loss, tunnel vision")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Hearing impairment or loss")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Memory loss, mental confusion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Loss of consciousness")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Pseudoseizure")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Dissociation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "centert"
  }, [_vm._v("Hallucination in all five senses")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("If a person has significant anxiety in the form of cognitive-perceptual disruption and the therapist focuses on unconscious feelings, this patient will become mentally confused or develop some of these other phenomena.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Case Vignette: Cognitive-Perceptual Disruption")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man with paranoid personality disorder arrived in a treatment session rubbing his eyes but with absolutely no visible striated muscle anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" You’ll have to excuse me a little today; I’m a little foggy.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Foggy? ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Is your thinking kind of foggy, cloudy? ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Foggy and cloudy.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How’s your vision? ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Cloudy.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Is it tunnel vision, or is it like looking through a screen? ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" More tunnel vision.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" More like it’s hard to see the outside of your visual field, but you can see straight ahead in the room. ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" When did that start? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Um, two, maybe two days ago relatively … like I just noticed it this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So this is what we looked at as anxiety, right? ["), _c('em', [_vm._v("Pressure to remember previously learned material")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" And the last two days, all day? ["), _c('em', [_vm._v("Clarification of the experience")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Actually more or less just today when I woke up.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Okay, so why are you anxious right now? ["), _c('em', [_vm._v("Pressure to identify causes")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Is it anxiety?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" That’s what we figured when we’ve met before. ["), _c('em', [_vm._v("Pressure to remember previously learned material")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" It’s more of a completely stoned type of feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" It’s a disconnection kind of thing. Disconnected from what’s going on. ["), _c('em', [_vm._v("Clarification")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" And any thoughts about why you’re anxious this morning? ["), _c('em', [_vm._v("Pressure to identify causes")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I don’t think it has anything to do with coming here.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" You don’t think it has anything to do with coming in?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Not to do with coming to see you, no.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" You weren’t anxious about it?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" No, I don’t think so.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How do we account for that anxiety then? How are you accounting for it? ["), _c('em', [_vm._v("Pressure to identify causes")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I’ve got school tomorrow and I was thinking about school last night.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Why today though? ["), _c('em', [_vm._v("Pressure to identify causes")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Um, I don’t know. You’re right, cause it’s kind of subsiding!")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" It’s just come down now?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this vignette, the patient has no anxiety in the striated muscle. Could he tell the therapist about the emotions? No. He wasn’t conscious of his feelings or even his anxiety. This is why we call it "), _c('em', [_vm._v("unconscious")]), _vm._v(" anxiety. Since they are unaware of their feelings or anxiety, these patients often seek medical attention for these somatic symptoms.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("PROJECTION, PROJECTIVE IDENTIFICATION, AND SPLITTING")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early sessions, this patient projected his rage onto others and then feared them. By this treatment session, he had ceased projecting and was exploring his own feelings and the anxiety they triggered. As he trusted me and faced his feelings, anxiety began in the form of cognitive-perceptual disruption. Projection is a major defense against cognitive-perceptual disruption. By projecting his anger onto others, he did not have to experience unconscious anxiety over the intense rage within himself but he instead suffered conscious fear and rage about the rage he expected from others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("Like projection, projective identification goes with cognitive-perceptual disruption. Projective identification in this frame is the projection of aspects of oneself, such as the abuser, the neglector, or the critic. These projected parts may produce a concordant (we are both critics) or complementary reaction in others (you are controlling so I will defy you). "), _c('em', [_vm._v("Splitting")]), _vm._v(" refers to holding one-dimensional views of people and events to preclude any complex feelings and anxiety. Examples of splitting include idealization and devaluation of the self or others. This set of primitive defenses used in session is a third category of major resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patients with dissociative and psychotic disorders, at times, have these manifestations of major resistance. (See "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 16")]), _vm._v("–"), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(".)")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("MOTOR CONVERSION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another somatic pattern related to unconscious feelings and impulses is motor conversion. When motor conversion is active, instead of striated muscle tensing up, the patient goes weak and flat, losing power in one or more muscle groups. For example, the patient may lose the ability to move his arms, legs, or vocal cords. Sometimes, as in the case of tremor, the patient experiences excess tension alternating with weakness in rapid cycles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the patient’s anxiety goes into conversion, he looks relaxed because he has no striated muscle tone. This is the well-known phenomenon of “la belle indifference” where the person appears relieved despite paralysis. The patient is neither anxious nor defensive because the anxiety and defense both are converted into weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To clarify, many neurologists also refer to striated muscle symptoms of unconscious anxiety as conversion, but the mechanism is obviously different. Patients with anxiety in the striated muscle rarely show la belle indifference; patients with motor conversion usually do. Patients with anxiety in the striated muscle will show signaling of a rise of unconscious feeling and anxiety; patients with motor conversion do not. Patients with anxiety in the striated muscle will be tense and strong; patients with motor conversion will show no tension and lots of weakness. Patients with anxiety in the striated muscle will use tactical defenses and isolation of affect; patients with motor conversion will show few defenses since all the feelings and anxiety are repressed, "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("manifesting as weakness. Obviously, the treatment of these two categories of conversion will differ greatly.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Case Vignette: Motor Conversion")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man with episodic weakness with falling and becoming at times paralyzed for hours or days comes to the office by wheelchair. He is having a great deal of weakness and spasms and moving from side to side in the chair as if he could fall out.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" I understand you saw the neurologist about some problems and he suggested that we meet. What are the difficulties that you’re experiencing at this point in time? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" ["), _c('em', [_vm._v("Display of large-amplitude upper body spasms")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" You’re experiencing physical symptoms right now? ["), _c('em', [_vm._v("Clarification of symptoms, encouragement to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" What are you experiencing in your body, at this point, right now? What is it that you observe from inside? ["), _c('em', [_vm._v("Pressure to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Uh, well, I’m coherent. ["), _c('em', [_vm._v("Self-reflection with a clear head")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Um-hmm, what is it that you’re noticing in your body? ["), _c('em', [_vm._v("Encouragement to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Okay. ["), _c('em', [_vm._v("Self-reflection")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Are you aware of being anxious? ["), _c('em', [_vm._v("Encouragement to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" No, I’m not anxious.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Do you notice muscle tension? ["), _c('em', [_vm._v("Encouragement to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" You mean as far as being tense coming into the building?")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Muscle tension within your body. ["), _c('em', [_vm._v("Encouragement to self-reflect")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Oh yeah, I know that’s there.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Why is that there right now when you’re coming here to see me; what’s causing that? What feelings are driving that tension in the body? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Response to Focused Process")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After seven minutes of focusing on the bodily experiences and what underlying emotions he had, the patient becomes much more relaxed and the spasms stop. He has no sighing and hand clenching, suggesting the emotional forces are manifesting as conversion. He begins "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("to focus on conflict with his new wife that predated these symptoms, which began one year prior.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" My wife likes to have things a certain way, and sometimes she goes off yelling and cursing.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Um-hmm.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" And it really pisses me off.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" So this was a certain time when you were home and that happened? ["), _c('em', [_vm._v("Pressure to be specific")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" I could hear her walking around the hallway swearing.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How did you feel toward her? ["), _c('em', [_vm._v("Pressure to identify feelings")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Very angry!")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" How does that feel in your body when you think about that—in your body? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" In my body. ["), _c('em', [_vm._v("Self-reflection")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Th:")]), _vm._v(" Thinking about it now, what are you noticing that tells you that you feel very angry inside? ["), _c('em', [_vm._v("Pressure to experience rage")]), _vm._v(".]")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Pt:")]), _vm._v(" Gosh! ["), _c('em', [_vm._v("Self-reflection; draws a large sigh")]), _vm._v(".]")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("Conversion to Striated Muscle Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This patient’s sigh is a marker of a shift from conversion to the striated muscle anxiety pathway. This transition is a direct product of focused pressure to mobilize his unconscious emotions, coupled with efforts for him to observe his body and isolate affect. When he started to isolate affect, the emotional forces shifted from conversion to striated muscle anxiety. From this state he went on to experience some complex feelings about his wife, including a small amount of somatic anger and guilt. These feelings with his wife became linked to complex feelings about his mother from past verbal abuse. His mother is now a nice, older woman: the conflict with his wife has mobilized this unresolved rage and guilt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the session, the patient is quite strong in all his limbs and walks out with no need for his cane or wheelchair. What took place is the process of replacing motor conversion with emotional experience. We explored feeling gradually to change the pathway of anxiety discharge from motor conversion into the striated muscle. "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _vm._v(" describes this “graded format” in great detail, but the principle is "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("this: if the therapist helps the patient isolate affect, unconscious anxiety shifts to the striated muscle.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("MAJOR RESISTANCE OF GUILT")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A fourth category of major resistance is resistance of guilt or the punitive superego (punishing conscience), a force that Davanloo calls the "), _c('em', [_vm._v("perpetrator of the unconscious")]), _vm._v(" (Davanloo 1987b, 1988, 2005). This resistance of guilt refers to a built-in need to defeat and sabotage the treatment process to avoid the experience of unconscious impulses and feelings. This resistance is driven by intense guilt about murderous and primitive rage toward loved ones and is seen in highly resistant and fragile patients. Unconscious guilt drives an overbuilt conscience that punishes the patient for his complex feelings: the patient harms himself to avoid guilt over his wish to harm others. The result is damage to relationships, reduced insight into oneself, loss of productivity and limited enjoyment of life. Anytime the therapist approaches the patient’s complex feelings, the resistance of the superego will interrupt the session. This resistance is a formidable foe to the therapy process, requiring extensive efforts to turn the patient against it; it is the essence of treatment resistance in psychiatric conditions. The patient cannot let himself succeed in the bond with the therapist due to massive guilt about rage toward loved ones. In response, use well-timed pressure, challenge, and head-on collision to overcome this powerful resistance. (See "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(".)")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("SUMMARY: MAJOR DEFENSES AND SOMATIC PATTERNS")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Thus, we see specific somatic patterns of unconscious anxiety and the defense of motor conversion. These four patterns (striated muscle, smooth muscle, cognitive-perceptual disruption, and conversion) correspond to patterns of major resistance. Recognition of these patterns can directly inform how to proceed with psychotherapy. (See "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02tab4"
    }
  }, [_vm._v("table 2.4")]), _vm._v(".) Some patients have different anxiety pathways predominant at different times, so we will review interventions used to manage each of these.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "tab-cap",
    attrs: {
      "id": "ch02tab4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('strong', [_vm._v("Table 2.4 Corresponding somatic and resistance patterns")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Somatic pattern")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Corresponding resistance")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Striated (voluntary) muscle")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Isolation of affect")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Smooth muscle")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Repression")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Motor conversion")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Repression")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Cognitive-perceptual disruption")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Projection, projective identification, splitting, repression")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Any of the above patterns")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Resistance of guilt (punitive superego)")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("TACTICAL DEFENSES")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In contrast to major defenses, tactical defenses are loosely held and easily penetrated or bypassed—they are satellites around the major defenses or can constitute the entire set of defenses a patient uses (Davanloo 1996a, b). Rather than a dichotomy, these defenses are on a continuum from tactical to major defenses. (See "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02fig2"
    }
  }, [_vm._v("fig. 2.2")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "ch02fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "97",
      "src": "images/f0024-01.jpg",
      "width": "469"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-cap"
  }, [_vm._v("Figure 2.2 Continuum of tactical to major defenses")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Several types of tactical defenses exist, including the following:")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Cover words:")]), _vm._v(" using words to hide one’s true feelings")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanga"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Cover words for anger:")]), _vm._v(" “It bugged me” or “I’m annoyed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanga"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Confusion as a tactical defense:")]), _vm._v(" “I’m confused.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanga"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Cover words for murderous rage:")]), _vm._v(" “I’m frustrated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanga"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Cover words for emotional closeness:")]), _vm._v(" “I’m embarrassed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanga"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Covers words like silly or dumb:")]), _vm._v(" “It was a silly situation to be in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Defensive weeping:")]), _vm._v(" using regressive defenses")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Blanket statements:")]), _vm._v(" saying for example “I was completely overwhelmed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Use of jargon:")]), _vm._v(" making statement such as “I was full of existential angst.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Indirect speech:")]), _vm._v(" stating for example “I was probably mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Rumination:")]), _vm._v(" rambling nonspecifically without a focus or target")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Vagueness:")]), _vm._v(" responding to a question with a vague statement")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('em', [_vm._v("Rationalization:")]), _vm._v(" explaining the reason for a feeling rather than the feeling itself")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Intellectualization:")]), _vm._v(" giving a description devoid of emotional experience")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Generalization:")]), _vm._v(" being nonspecific")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Diversification:")]), _vm._v(" avoiding the focus")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Not remembering:")]), _vm._v(" suppressing and ignoring emotions")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Denial:")]), _vm._v(" not acknowledging what one is actually experiencing or doing")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Externalization:")]), _vm._v(" blaming others for internal problems")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Obsessional indecisiveness:")]), _vm._v(" not committing to specifics about problems or emotions")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Stubbornness, defiance:")]), _vm._v(" exhibiting oppositional conduct")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Tangents:")]), _vm._v(" avoiding specific focus on feelings or problems")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Somatization:")]), _vm._v(" describing symptoms rather than actual feelings")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Talking to avoid the experience of feelings:")]), _vm._v(" continuing to speak so feelings are not felt")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Body movement as defense against feelings:")]), _vm._v(" avoiding eye contact for example")]), _vm._v(" "), _c('p', {
    staticClass: "indenthang"
  }, [_c('span', {
    staticClass: "none"
  }), _c('em', [_vm._v("Passive compliance:")]), _vm._v(" going along with the therapist")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To determine whether a defense is a tactical defense versus part of the major resistance, the therapist should interrupt or ignore it and see whether it goes away. If the defense keeps coming back, it is likely part of the tightly maintained major resistances against murderous rage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many ways to handle tactical defenses including clarifying, pressuring, ignoring, blocking, and challenging (Davanloo 2005). In general, tactical defenses can be ignored so long as there is continued rise in unconscious signals and access to feelings. If the patient keeps using a tactical defense, it is more a part of major resistance and it will need to be clarified and challenged directly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Low resistance patients")]), _vm._v(" use only tactical defenses. "), _c('em', [_vm._v("Moderately resistant patients")]), _vm._v(" use both tactical and major defenses. "), _c('em', [_vm._v("Highly resistant patients")]), _vm._v(" with repression and "), _c('em', [_vm._v("fragile character structure patients")]), _vm._v(" may lack tactical defenses, so they succumb to major defenses of repression and projection.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('strong', [_vm._v("CONSCIOUS VERSUS UNCONSCIOUS FEELINGS AND ANXIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As described above, patients are unaware of unconscious anxiety and what drives it. In contrast, conscious anxiety is noticed and experienced. For example, when first visiting a surgeon, patients will be anxious about what will happen and what the outcome will be. This type of anxiety is primarily cognitive in the form of worry and may be accompanied by some muscle tension in anticipation of pain or bad news. This anxiety is adaptive and matches the context; it is also transitory. This anxious event may also activate unconscious anxiety and result in, for example, diarrhea prior to such an appointment; in this case, both conscious and unconscious anxiety are present.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Similarly, conscious emotions are experienced and linked to conscious stimuli. For example, conscious anger is experienced by someone being provoked by harsh comments from a critical boss. Such conscious experiences are devoid of unconscious anxiety and defense. This conscious anger may, however, activate unconscious unprocessed feelings, such as guilt-laden rage from childhood criticism; in this case, unconscious anxiety and defense will be activated.")]), _vm._v(" "), _c('div', {
    staticClass: "none"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_c('em', [_vm._v("There are four main formats of somatic manifestation of activated unconscious impulses and feelings and corresponding categories of major resistance. Many forms of tactical defenses may exist separately or be more or less part of major resistance. Tactical and major defenses are on a continuum. These defenses are all signals of activated unconscious impulses and feelings. Conscious feelings and anxiety are triggered by conscious stimuli and do not have unconscious anxiety or defense as a component")])]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "none"
  }, [_c('hr')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 84
// module chunks = 0